import React, { useEffect, useState } from "react";
import "./aboutpage.css";
import AboutImage from "../assest/Boudh.jpg";
import Dhealnavbar from "../Navbar/dhealnavbar";
import { useTranslation } from "react-i18next";

export default function AboutPage({
  toggleTheme,


  
}) {        
  const { t } = useTranslation();
  const [fontSize, setFontSize] = useState(100);

  const increaseFont = () => setFontSize((prev) => Math.min(prev + 10, 150));
  const decreaseFont = () => setFontSize((prev) => Math.max(prev - 10, 70));
  const resetFont = () => setFontSize(100);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page-wrapper"
    style={{ fontSize: fontSize + "%" }}
    >
      {/* 🔹 Navbar */}
      <Dhealnavbar
  toggleTheme={toggleTheme}
  increaseFont={increaseFont}
  decreaseFont={decreaseFont}
  resetFont={resetFont}
/>

      <div className="about-container">
        <img
          src={AboutImage}
          alt={t("aboutPage.titleImageAlt")}
          className="about-image"
        />

        <h1>{t("aboutPage.heading")}</h1>

        <p>{t("aboutPage.description")}</p>

        <p>{t("aboutPage.historyParagraph1")}</p>

        {/* <h2>{t("aboutPage.genealogyHeading")}</h2> */}

        {/* <ul>
          {t("aboutPage.kings", { returnObjects: true }).map((king, index) => (
            <li key={index}>{king}</li>
          ))}
        </ul> */}

        <p>{t("aboutPage.historyParagraph2")}</p>
      </div>
    </div>
  );
}
